// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___23STW","flex":"flex___1IcSz","label":"label___bmZ3k","left":"left___1iE6D","divider":"divider___2rZX5"};